import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(10 * 60 + 48); // 10 minutes 48 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 w-full bg-red-600 text-white z-50 py-2 px-4 shadow-md" data-id="element-170">
      <div className="max-w-7xl mx-auto flex justify-center items-center gap-2 md:gap-4 text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-171">
        <Clock className="w-5 h-5 animate-pulse" data-id="element-172" />
        <span data-id="element-173">Esta oferta termina pronto:</span>
        <span className="bg-white text-red-600 px-2 py-0.5 rounded font-mono text-lg" data-id="element-174">
          {formatTime(timeLeft)}
        </span>
      </div>
    </div>;
}